/**
 * @class
 * @description This class reports current pluguin status to the DB
 * @exports StatsReportingBusinessObject
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import StatsBean from '../Beans/StatsBean';
import Cdn from './../Loaders/Cdn';
export default class StatsReportingBusinessObject {
    constructor(loader) {
        this.started = false;
        this.stopped = false;
        // private lastBytes: number = 0;
        this.lastStats = new Map();
        this.loader = loader;
    }
    start(host, token, accountCode, profileName, resource) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.started)
                return;
            this.started = true;
            this.report(host, token, accountCode, profileName, resource);
        });
    }
    report(host, token, accountCode, profileName, resource) {
        // let bytes = 0;
        try {
            if (!this.stopped) {
                let statsMap = new Map();
                let cdns = new Map(this.loader.CDNLoader.getCdnList());
                cdns.forEach((cdn) => {
                    let cloned = Object.assign({}, cdn);
                    let lastCdnStats = this.lastStats.get(cdn.name);
                    let downloadedBytes = cloned.downloadedBytes;
                    let downloadedChunks = cloned.downloadedChunks;
                    let totalFailures = cloned.totalFail;
                    let millis = cloned.downloadMillis;
                    let bannedCount = cloned.bannedCount;
                    let unBannedCount = cloned.unBannedCount;
                    let avgPingTime = cloned.avgPingTime;
                    if (lastCdnStats) {
                        downloadedBytes = downloadedBytes - lastCdnStats.downloadedBytes;
                        downloadedChunks = downloadedChunks - lastCdnStats.downloadedChunks;
                        totalFailures = totalFailures - lastCdnStats.totalFail;
                        millis = millis - lastCdnStats.downloadMillis;
                        bannedCount = bannedCount - lastCdnStats.bannedCount;
                        unBannedCount = bannedCount - lastCdnStats.unBannedCount;
                        avgPingTime = avgPingTime - lastCdnStats.avgPingTime;
                    }
                    if (downloadedBytes != 0) {
                        let statsBean = new StatsBean(cdn.name, cdn.provider, downloadedBytes, downloadedChunks, totalFailures, millis, cdn.highestSegmentBandwidth, cdn.lowestSegmentBandwidth, bannedCount, unBannedCount, cdn.avgPingTime, cdn.lowestPingTime, cdn.highestPingTime, cdn.banned, cdn.active);
                        statsMap.set(cdn.name, statsBean);
                        this.lastStats.set(cdn.name, cloned);
                    }
                });
                if (this.loader.P2PLoader.isEnabled) {
                    let p2pStats = this.loader.P2PLoader.getStats();
                    let lastCdnStats = this.lastStats.get("P2P");
                    let downloadedBytes = p2pStats.downloadedBytes;
                    let downloadedChunks = p2pStats.downloadedSegments;
                    let millis = p2pStats.downloadMillis;
                    if (lastCdnStats) {
                        downloadedBytes = downloadedBytes - lastCdnStats.downloadedBytes;
                        downloadedChunks = downloadedChunks - lastCdnStats.downloadedChunks;
                        millis = millis - lastCdnStats.downloadMillis;
                    }
                    if (downloadedBytes != 0) {
                        let statsBean = new StatsBean("P2P", "P2P", downloadedBytes || 0, downloadedChunks || 0, 0, millis, 0, 0, 0, 0, 0, 0, 0, false, true);
                        statsMap.set("P2P", statsBean);
                        let cdn = new Cdn("P2P", "P2P", "", 0, false);
                        cdn.downloadedBytes = p2pStats.downloadedBytes;
                        cdn.downloadedChunks = p2pStats.downloadedSegments;
                        cdn.downloadMillis = p2pStats.downloadMillis;
                        this.lastStats.set("P2P", cdn);
                    }
                    //bytes = p2pStats.downloadedBytes;
                }
                let jsonObject = {};
                statsMap.forEach((value, key) => {
                    jsonObject[key] = value;
                });
                if (statsMap.size > 0) { // &&  bytes>this.lastBytes ){
                    // this.lastBytes = bytes;
                    this.reportRequest(host, token, accountCode, profileName, resource, JSON.stringify(jsonObject));
                }
            }
        }
        catch (e) { }
        setTimeout(function () {
            StatsReportingBusinessObject.getInstance().report(host, token, accountCode, profileName, resource);
        }, 5000);
    }
    reportRequest(host, token, accountCode, profileName, resource, detail) {
        if (detail == "" || detail == "{}") {
            return;
        }
        const paramsObject = {
            token: token,
            accountCode: accountCode,
            profileName: profileName,
            data: detail
        };
        let target = new URL("https://" + host + "/cdn");
        target.search = new URLSearchParams(paramsObject).toString();
        let request = new XMLHttpRequest();
        request.open("GET", target.toString());
        request.send();
    }
    static getInstance(loader) {
        if (this._instance == undefined && loader != undefined) {
            this._instance = new StatsReportingBusinessObject(loader);
        }
        return this._instance;
    }
}
